import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getGameInfo, redicrectAuth } from "../../api";
import ReactDice from "react-dice-complete";
import { initData } from "@telegram-apps/sdk";
import "./Archived.css";

const Header = ({ id }) => {
  const userName =
    initData.user().firstName || initData.user().username || initData.user().id;

  const avatar = initData.user().photoUrl || "/avatar.svg";

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        alert("ID copied to clipboard!");
      })
      .catch((err) => {
        console.error(`Error while copying: ${err}`);
      });
  };

  return (
    <div className="header">
      <div className="userinfo">
        <img className="avatar" src={avatar} />
        <div>
          <div className="userid">{userName}</div>
          <div
            className="gamestatus"
            onClick={() => copyToClipboard(id)}
          >{`Game ${id}`}</div>
        </div>
      </div>
    </div>
  );
};

const DiceComponent = ({ gameState }) => {
  const userId = localStorage.getItem("user_id");

  return (
    <div className="game">
      <div className="dice">
        <ReactDice
          defaultRoll={Number(gameState.playerDice)}
          numDice={1}
          rollTime={0}
          disableIndividual
          rollDone={(x, y) => {}}
          dieSize={160}
          dotColor="#191919"
          faceColor="radial-gradient(circle, rgba(242,241,247,1) 0%, rgba(192,194,211,1)"
        />
      </div>
      <div>
        {gameState.winner == userId && (
          <div className="resultblock">
            <img className="emoji" src="/trophy_emoji.svg" alt="wonimg" />
            <div className="wontext">Victory!</div>
            <img className="emoji" src="/trophy_emoji.svg" alt="wonimg" />
          </div>
        )}
        {gameState.winner != userId && (
          <div className="resultblock">
            <img className="emoji" src="/loose_emoji.svg" alt="looseimg" />
            <div className="loosetext">Defeat</div>
            <img className="emoji" src="/loose_emoji.svg" alt="looseimg" />
          </div>
        )}
        <div className="betcontainer">
          <img src="/ton.png" alt="toncoin" className="betimage" />
          <div className="textbet">{gameState.bet}</div>
        </div>
      </div>
      <div>
        <ReactDice
          defaultRoll={Number(gameState.opponentDice)}
          numDice={1}
          rollTime={0}
          disableIndividual
          rollDone={(x, y) => {}}
          dieSize={180}
          dotColor="#191919"
          faceColor="radial-gradient(circle, rgba(242,241,247,1) 0%, rgba(192,194,211,1)"
        />
      </div>
    </div>
  );
};

const ArchivedView = ({}) => {
  if (redicrectAuth()) {
    window.location.href = "/";
  }

  const { id } = useParams();
  const [error, setError] = useState("");
  const userId = localStorage.getItem("user_id");

  const [gameState, setGameState] = useState({
    playerDice: "",
    opponentDice: "",
    winner: null,
    bet: null,
  });

  const navigate = useNavigate();

  const onDataReceived = (data) => {
    let playerDice = "";
    let opponentDice = "";
    for (const playerId in data.state.dices) {
      const score = data.state.dices[playerId];
      if (playerId === userId) {
        playerDice = `${score}`;
      } else {
        opponentDice = `${score}`;
      }
    }

    setGameState((prevState) => ({
      ...prevState,
      playerDice: playerDice,
      opponentDice: opponentDice,
      winner: data.state.winner,
      bet: data.state.bet,
    }));
  };
  useEffect(() => {
    getGameInfo(id, true, onDataReceived, setError);
  }, []);

  const exit = () => {
    setTimeout(() => {
      navigate("/menu");
    }, 200);
  };

  return (
    <div className="parent">
      <Header id={id} />
      {error && <p className="error">{error}</p>}
      {gameState.bet && <DiceComponent gameState={gameState} />}
      <div className="bottom">
        <button className="invitebutton" onClick={exit}>
          Back
        </button>
      </div>
    </div>
  );
};

export default ArchivedView;
